import { request } from "utils/legacy_api";

export function index(page = 1) {
  return request(`/questionnaire_performances?page=${page}`, { method: "GET" });
}

export function get(id: number) {
  return request(`/questionnaire_performances/${id}`, {
    method: "GET"
  });
}
